/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
//fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});
jQuery(window).scroll(function(){
  if (jQuery(window).scrollTop() >= 150) {
    jQuery('.site-header').addClass('fixed-header');
  }
  else {
    jQuery('.site-header').removeClass('fixed-header');
  }
});
jQuery(".menu-icon").click(function(){
  jQuery(".menu-icon").toggleClass("active");
  jQuery(".menu-list").toggleClass("active");
  jQuery("body").toggleClass("active");
});
jQuery(".menu-list-inner ul li a").click(function(){
  jQuery(".menu-icon").removeClass("active");
  jQuery(".menu-list").removeClass("active");
  jQuery("body").removeClass("active");
 
});
jQuery(".news-popup-top .close-btn a").click(function(){
  jQuery(".news-popup-section").addClass("active");
});
jQuery(function () {
  jQuery(".news-all-detail .news-one-box").slice(0, 6).show();
  jQuery("#loadMore1").on('click', function (e) {
      e.preventDefault();
      jQuery(".news-all-detail .news-one-box:hidden").slice(0, 6).slideDown();
      if (jQuery(".news-all-detail .news-one-box:hidden").length == 0) {
        jQuery("#loadMore1").text("No Content").addClass("noContent");
      }
  });
  jQuery(".news-all-detail .news-two-box").slice(0, 6).show();
  jQuery("#loadMore2").on('click', function (e) {
      e.preventDefault();
      jQuery(".news-all-detail .news-two-box:hidden").slice(0, 6).slideDown();
      if (jQuery(".news-all-detail .news-two-box:hidden").length == 0) {
        jQuery("#loadMore2").text("No Content").addClass("noContent");

      }
  });
  
  jQuery('.share-icon-popup-main').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function() {
        jQuery("body").addClass("overflow");
        jQuery('.cpylink').on('click', function(e) {

          e.preventDefault();
                          
          var $temp = jQuery("<input class='d-none'>");
          //var url = jQuery(this).attr('href');
          var value = jQuery(this).attr('href');
         
          jQuery(".mfp-fade").append($temp);
              $temp.val(value).select();
              document.execCommand("copy");
              $temp.remove();            
        });
     },
      close: function() {
        jQuery("body").removeClass("overflow");
      }
    }
  });
   
  jQuery(".news-tab").click(function () {
    if (jQuery(this).hasClass('active')) {
    } else {
      var tabid = jQuery(this).attr('id');
      jQuery(".news-tab").removeClass('active');
      jQuery(this).addClass('active');
      jQuery(".news-tab-content").removeClass('active');
      jQuery("#" + tabid + "-content").addClass("active");
    }
    return false;
});

jQuery('.leadership-image-slider-nav-rtl ').slick({
  slidesToShow: 2.8,
                slidesToScroll: 1,
                asNavFor: '.leadership-text-slider-for-rtl',
                dots: false,
                arrows:false,
                cssEase: 'linear',
                focusOnSelect: true,
                adaptiveHeight: true,
                infinite: true,
                rtl:true,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: "0px",
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "0px",
                    }
                }]
});
jQuery('.leadership-text-slider-for-rtl').slick({
  lazyLoad: 'progressive',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  cssEase: 'linear',
  asNavFor: '.leadership-image-slider-nav-rtl',
  adaptiveHeight: true,
  rtl:true,
});

});

jQuery(document).ready(function(){
  
  Weglot.on("languageChanged", function(newLang, prevLang) {
    if(newLang == 'ar'){
      jQuery('html').attr("dir", 'rtl');
      jQuery('body').addClass('rtl');
      jQuery('.news-latest-one').addClass('rtl');
      jQuery('.news-latest-one').slick('refresh');
      jQuery('.hero-slider-banner-video').addClass('rtl');
      jQuery('.hero-slider-banner-video').slick('refresh');
      jQuery('.our-portfolio-one').addClass('rtl');
      jQuery('.our-portfolio-one').slick('refresh');
      jQuery('.leadership-text-slider-for').addClass('rtl');
      jQuery('.leadership-text-slider-for').slick('refresh');
      jQuery('.leadership-image-slider-nav').addClass('rtl');
      jQuery('.leadership-image-slider-nav').slick('refresh');
      jQuery('.leadership-image-slider-mobile').addClass('rtl');
      jQuery('.leadership-image-slider-mobile').slick('refresh');      
    }
    else{
      jQuery('html').attr("dir", 'ltr');
      jQuery('body').removeClass('rtl');
      jQuery('.news-latest-one').removeClass('rtl');
      jQuery('.news-latest-one').slick('refresh');
      jQuery('.hero-slider-banner-video').removeClass('rtl');
      jQuery('.hero-slider-banner-video').slick('refresh');
      jQuery('.our-portfolio-one').removeClass('rtl');
      jQuery('.our-portfolio-one').slick('refresh');
      jQuery('.leadership-text-slider-for').removeClass('rtl');
      jQuery('.leadership-text-slider-for').slick('refresh');
      jQuery('.leadership-image-slider-nav').removeClass('rtl');
      jQuery('.leadership-image-slider-nav').slick('refresh');
      jQuery('.leadership-image-slider-mobile').removeClass('rtl');
      jQuery('.leadership-image-slider-mobile').slick('refresh');
    }
    //console.log("The language on the page just changed to (code): " + newLang)
    //console.log("The full name of the language is: " + Weglot.getLanguageName(newLang))
});

jQuery('.career-content-detail .accordion__item_title').click(function(j) {
  var dropDown = jQuery(this).closest('.accordion__item').find('.accordion__item_detail');
  jQuery(this).closest('.accordion').find('.accordion__item_detail').not(dropDown).slideUp();
  if (jQuery(this).hasClass('active')) {
    jQuery(this).removeClass('active');
    
  } else {
    jQuery(this).closest('.accordion').find('.accordion__item_title.active').removeClass('active');
    jQuery(this).addClass('active');
  }
  dropDown.stop(false, true).slideToggle();
  j.preventDefault();
});
 
});
  